module.exports = __webpack_public_path__ + "img/22.b9e604ad.svg";